export const env = {
  ALA_ENV: process.env.NEXT_PUBLIC_ALA_ENV,
  USE_REACT_SCAN: process.env.USE_REACT_SCAN === "true",
  HEADLESS_MODE: process.env.NEXT_PUBLIC_HEADLESS_MODE === "true",
  DEBUG_TOOLBAR: process.env.NEXT_PUBLIC_DEBUG_TOOLBAR === "true",
};
